export default __webpack_public_path__ + "31e85b2a15f484e999d6b380377c74c2.png";